import { GridColDef } from "@mui/x-data-grid";
import { headerWithHelp } from "../generic-grid/headerWithHelp";

export const workOrderStateColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
  {
    field: "ordinal",
    headerName: "Order",
    flex: 1,
    renderHeader: () =>
      headerWithHelp(
        "Order",
        "This is the order that it should display in the drop down when selecting a work order state"
      ),
  },
  {
    field: "showInDispatch",
    headerName: "Show In Dispatch",
    flex: 1,
    renderHeader: () =>
      headerWithHelp(
        "Show In Dispatch",
        "When enabled, This will display any work order with this work order state in the Unscheduled section on the Dispatch page"
      ),
  },
  { field: "showForTech", headerName: "Show For Tech", flex: 1 },
];
